export const environment = {
  production: false,
  urlApi: "https://api.pentviewdev.com",
  urlCrmWs: "https://api.pentviewdev.com",
  languages: ["en", "es", "de", "ar", "zh-CN", "zh-TW", "he", "ru"],
  password: "templates@",
  turnstileSiteKey: "0x4AAAAAAE-_JmEehkq-P9QO",
};
